import { render, staticRenderFns } from "./clientView.vue?vue&type=template&id=480e8bae&scoped=true&"
import script from "./clientView.vue?vue&type=script&lang=js&"
export * from "./clientView.vue?vue&type=script&lang=js&"
import style0 from "./clientView.vue?vue&type=style&index=0&id=480e8bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e8bae",
  null
  
)

component.options.__file = "clientView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDataTable,
  VFlex,
  VProgressCircular,
})
